import { declension } from '~/assets/functions/declension'

export const filterBonus = (num: number) => {
  return declension(num, ['бонус', 'бонуса', 'бонусов'])
}
